// provinces + districts + sample addresses
const provincesData = {
    "กรุงเทพ": {
        "อำเภอเมือง": [
            { "address": "123 ถนนสุขุมวิท กรุงเทพ", "lat": 13.736, "lng": 100.563 },
            { "address": "45 ถนนเพชรบุรี กรุงเทพ", "lat": 13.752, "lng": 100.567 },
            { "address": "67 ถนนราชดำเนิน กรุงเทพ", "lat": 13.756, "lng": 100.501 },
            { "address": "89 ถนนสีลม กรุงเทพ", "lat": 13.727, "lng": 100.533 },
            { "address": "10 ถนนพหลโยธิน กรุงเทพ", "lat": 13.813, "lng": 100.556 }
        ],
        "เขตคลองเตย": [
            { "address": "1234 ถนนสุขุมวิท กรุงเทพ", "lat": 13.722, "lng": 100.563 },
            { "address": "44 ถนนเพชรบุรี กรุงเทพ", "lat": 13.750, "lng": 100.565 },
            { "address": "674 ถนนราชดำเนิน กรุงเทพ", "lat": 13.757, "lng": 100.500 }
        ]
    },
    "ปทุมธานี": {
        "อำเภอคลองหลวง": [
            { "address": "88 หมู่ 5 ปทุมธานี", "lat": 14.064, "lng": 100.647 },
            { "address": "99 หมู่ 9 ปทุมธานี", "lat": 14.067, "lng": 100.645 },
            { "address": "111 ถนนรังสิต ปทุมธานี", "lat": 14.030, "lng": 100.616 }
        ]
    },
    "สงขลา": {
        "อำเภอหาดใหญ่": [
            { "address": "22 ถนนกาญจนวนิช สงขลา", "lat": 7.013, "lng": 100.476 },
            { "address": "55 ถนนเพชรเกษม สงขลา", "lat": 7.004, "lng": 100.495 },
            { "address": "99 ถนนลพบุรีราเมศวร์ สงขลา", "lat": 6.996, "lng": 100.498 }
        ]
    },
    "เชียงใหม่": {
        "อำเภอเมือง": [
            { "address": "12 ถนนนิมมานฯ เชียงใหม่", "lat": 18.796, "lng": 98.979 },
            { "address": "33 ถนนสุเทพ เชียงใหม่", "lat": 18.788, "lng": 98.968 },
            { "address": "44 ถนนเจริญเมือง เชียงใหม่", "lat": 18.783, "lng": 99.018 }
        ]
    },
    "ขอนแก่น": {
        "อำเภอเมือง": [
            { "address": "111 ถนนมิตรภาพ ขอนแก่น", "lat": 16.432, "lng": 102.823 },
            { "address": "222 ถนนศรีจันทร์ ขอนแก่น", "lat": 16.432, "lng": 102.836 },
            { "address": "333 ถนนกลางเมือง ขอนแก่น", "lat": 16.436, "lng": 102.830 }
        ]
    },
    "ชลบุรี": {
        "อำเภอบางละมุง": [
            { "address": "55 ถนนสุขุมวิท ชลบุรี", "lat": 12.923, "lng": 100.882 },
            { "address": "66 ถนนบางละมุง ชลบุรี", "lat": 12.935, "lng": 100.889 },
            { "address": "77 ถนนพัทยา ชลบุรี", "lat": 12.936, "lng": 100.883 }
        ]
    },
    "นครราชสีมา": {
        "อำเภอเมือง": [
            { "address": "10 ถนนมิตรภาพ นครราชสีมา", "lat": 14.978, "lng": 102.097 },
            { "address": "20 ถนนราชดำเนิน นครราชสีมา", "lat": 14.973, "lng": 102.100 },
            { "address": "30 ถนนกลางเมือง นครราชสีมา", "lat": 14.975, "lng": 102.103 }
        ]
    },
    "ภูเก็ต": {
        "อำเภอเมือง": [
            { "address": "100 ถนนถลาง ภูเก็ต", "lat": 7.884, "lng": 98.391 },
            { "address": "101 ถนนเยาวราช ภูเก็ต", "lat": 7.883, "lng": 98.389 },
            { "address": "102 ถนนรัษฎา ภูเก็ต", "lat": 7.885, "lng": 98.393 }
        ]
    },
    "ตาก": {
        "อำเภอแม่สอด": [
            { "address": "12 ถนนริมเมย ตาก", "lat": 16.716, "lng": 98.567 },
            { "address": "13 ถนนสุขสวัสดิ์ ตาก", "lat": 16.714, "lng": 98.569 },
            { "address": "14 ถนนมหาราช ตาก", "lat": 16.712, "lng": 98.566 }
        ]
    },
    "สุราษฎร์ธานี": {
        "อำเภอเมือง": [
            { "address": "50 ถนนนารายณ์ สุราษฎร์ธานี", "lat": 9.141, "lng": 99.329 },
            { "address": "51 ถนนเกษตร สุราษฎร์ธานี", "lat": 9.145, "lng": 99.327 },
            { "address": "52 ถนนศรีวิชัย สุราษฎร์ธานี", "lat": 9.149, "lng": 99.331 }
        ]
    },
    "นครปฐม": {
        "อำเภอเมือง": [
            { "address": "10 ถนนเพชรเกษม นครปฐม", "lat": 13.818, "lng": 100.043 },
            { "address": "11 ถนนราชดำเนิน นครปฐม", "lat": 13.819, "lng": 100.046 },
            { "address": "12 ถนนรัตนโกสินทร์ นครปฐม", "lat": 13.820, "lng": 100.047 }
        ]
    },
    "ราชบุรี": {
        "อำเภอเมือง": [
            { "address": "12 ถนนจันทร์ ราชบุรี", "lat": 13.545, "lng": 99.819 },
            { "address": "13 ถนนประจักษ์ ราชบุรี", "lat": 13.546, "lng": 99.820 },
            { "address": "14 ถนนวรเดช ราชบุรี", "lat": 13.547, "lng": 99.821 }
        ]
    },
    "พิษณุโลก": {
        "อำเภอเมือง": [
            { "address": "1 ถนนบรมไตรโลกนารถ พิษณุโลก", "lat": 16.821, "lng": 100.265 },
            { "address": "2 ถนนพิชัย พิษณุโลก", "lat": 16.823, "lng": 100.268 },
            { "address": "3 ถนนจันทน์แก้ว พิษณุโลก", "lat": 16.825, "lng": 100.270 }
        ]
    },
    "บุรีรัมย์": {
        "อำเภอเมือง": [
            { "address": "10 ถนนกุดพิมาน บุรีรัมย์", "lat": 14.994, "lng": 102.033 },
            { "address": "11 ถนนสรรพสิทธิ์ บุรีรัมย์", "lat": 14.996, "lng": 102.037 },
            { "address": "12 ถนนจิระ บุรีรัมย์", "lat": 14.998, "lng": 102.040 }
        ]
    },
    "นครสวรรค์": {
        "อำเภอเมือง": [
            { "address": "50 ถนนโคกเดื่อ นครสวรรค์", "lat": 15.705, "lng": 100.128 },
            { "address": "51 ถนนสวรรค์ชัยชาญ นครสวรรค์", "lat": 15.708, "lng": 100.130 },
            { "address": "52 ถนนนวมินทร์ นครสวรรค์", "lat": 15.710, "lng": 100.132 }
        ]
    },
    "ลำปาง": {
        "อำเภอเมือง": [
            { "address": "10 ถนนเจริญเมือง ลำปาง", "lat": 18.288, "lng": 99.496 },
            { "address": "11 ถนนรอบเมือง ลำปาง", "lat": 18.290, "lng": 99.498 },
            { "address": "12 ถนนพหลโยธิน ลำปาง", "lat": 18.292, "lng": 99.500 }
        ]
    },
    "สมุทรสาคร": {
        "อำเภอเมือง": [
            { "address": "1 ถนนเศรษฐกิจ สมุทรสาคร", "lat": 13.532, "lng": 100.273 },
            { "address": "2 ถนนสมุทรสาคร สมุทรสาคร", "lat": 13.534, "lng": 100.275 },
            { "address": "3 ถนนมหาชัย สมุทรสาคร", "lat": 13.536, "lng": 100.277 }
        ]
    },
    "อุดรธานี": {
        "อำเภอเมือง": [
            { "address": "10 ถนนกลางเมือง อุดรธานี", "lat": 17.412, "lng": 102.788 },
            { "address": "11 ถนนประจักษ์ อุดรธานี", "lat": 17.414, "lng": 102.790 },
            { "address": "12 ถนนทหาร อุดรธานี", "lat": 17.416, "lng": 102.792 }
        ]
    },
    "ยะลา": {
        "อำเภอเมือง": [
            { "address": "1 ถนนสันติสุข ยะลา", "lat": 6.545, "lng": 101.279 },
            { "address": "2 ถนนยะลาใหม่ ยะลา", "lat": 6.547, "lng": 101.281 },
            { "address": "3 ถนนจรัสมิตร ยะลา", "lat": 6.549, "lng": 101.283 }
        ]
    },
    "แพร่": {
        "อำเภอเมือง": [
            { "address": "1 ถนนเจริญเมือง แพร่", "lat": 18.145, "lng": 100.141 },
            { "address": "2 ถนนสิงห์ชัย แพร่", "lat": 18.147, "lng": 100.143 },
            { "address": "3 ถนนพญาไท แพร่", "lat": 18.149, "lng": 100.145 }
        ]
    },
    "เชียงราย": {
        "อำเภอเมือง": [
            { "address": "10 ถนนแม่ฟ้าหลวง เชียงราย", "lat": 19.911, "lng": 99.835 },
            { "address": "11 ถนนประสานมิตร เชียงราย", "lat": 19.913, "lng": 99.837 },
            { "address": "12 ถนนสิงหราช เชียงราย", "lat": 19.915, "lng": 99.839 }
        ]
    },
    "สุโขทัย": {
        "อำเภอเมือง": [
            { "address": "10 ถนนสวรรคโลก สุโขทัย", "lat": 17.020, "lng": 99.823 },
            { "address": "11 ถนนเมืองเก่า สุโขทัย", "lat": 17.022, "lng": 99.825 },
            { "address": "12 ถนนพิพิธภัณฑ์ สุโขทัย", "lat": 17.024, "lng": 99.827 }
        ]
    },
    "ชัยภูมิ": {
        "อำเภอเมือง": [
            { "address": "10 ถนนจิระชัย ชัยภูมิ", "lat": 15.808, "lng": 102.035 },
            { "address": "11 ถนนหน้าเมือง ชัยภูมิ", "lat": 15.810, "lng": 102.037 },
            { "address": "12 ถนนสระบุรี ชัยภูมิ", "lat": 15.812, "lng": 102.039 }
        ]
    },
    "อ่างทอง": {
        "อำเภอเมือง": [
            { "address": "1 ถนนอ่างทอง อ่างทอง", "lat": 14.583, "lng": 100.453 },
            { "address": "2 ถนนบางระกำ อ่างทอง", "lat": 14.585, "lng": 100.455 },
            { "address": "3 ถนนศรีอ่างทอง อ่างทอง", "lat": 14.587, "lng": 100.457 }
        ]
    },
    "ลพบุรี": {
        "อำเภอเมือง": [
            { "address": "10 ถนนพหลโยธิน ลพบุรี", "lat": 14.799, "lng": 100.653 },
            { "address": "11 ถนนประตูชัย ลพบุรี", "lat": 14.801, "lng": 100.655 },
            { "address": "12 ถนนสิงห์ ลพบุรี", "lat": 14.803, "lng": 100.657 }
        ]
    }
};

// ฟังก์ชันสุ่ม array ของ addresses
function getRandomAddresses(province, district, count = 3) {
    const addresses = provincesData[province]?.[district] || [{ address: "ไม่ระบุ", lat: 0, lng: 0 }];
    const result = [];
    for (let i = 0; i < count; i++) {
        const randomIndex = Math.floor(Math.random() * addresses.length);
        result.push(addresses[randomIndex]);
    }
    return result;
}

// ฟังก์ชันช่วยสร้าง customerList
function createCustomerList(province, district) {
    return [
        {
            SNAM: 'นาย',
            NAME1: 'ก',
            NAME2: 'ก1',
            address: getRandomAddresses(province, district),
            phone: '081-111-1111',
            role: 'คนกู้',
            investigation: true
        },
        {
            SNAM: 'นาง',
            NAME1: 'ข',
            NAME2: 'ข1',
            address: getRandomAddresses(province, district),
            phone: '082-222-2222',
            role: 'คนค้ำ 1',
            investigation: true
        },
        {
            SNAM: 'นางสาว',
            NAME1: 'ค',
            NAME2: 'ค1',
            address: getRandomAddresses(province, district),
            phone: '083-333-3333',
            role: 'คนค้ำ 2',
            investigation: true
        }
    ];
}

export const mockContracts = [
    { key: 1, contno: 'V-0001', date: '2023-01-01', district: 'อำเภอเมือง', province: 'กรุงเทพ', customerList: createCustomerList('กรุงเทพ', 'อำเภอเมือง') },
    { key: 2, contno: 'V-00031', date: '2023-01-01', district: 'เขตคลองเตย', province: 'กรุงเทพ', customerList: createCustomerList('กรุงเทพ', 'เขตคลองเตย') },
    { key: 3, contno: 'V-00032', date: '2023-01-01', district: 'เขตคลองเตย', province: 'กรุงเทพ', customerList: createCustomerList('กรุงเทพ', 'เขตคลองเตย') },
    { key: 4, contno: 'V-0002', date: '2023-02-15', district: 'อำเภอคลองหลวง', province: 'ปทุมธานี', customerList: createCustomerList('ปทุมธานี', 'อำเภอคลองหลวง') },
    { key: 5, contno: 'V-0003', date: '2023-03-10', district: 'อำเภอหาดใหญ่', province: 'สงขลา', customerList: createCustomerList('สงขลา', 'อำเภอหาดใหญ่') },
    { key: 6, contno: 'V-0004', date: '2023-03-25', district: 'อำเภอเมือง', province: 'เชียงใหม่', customerList: createCustomerList('เชียงใหม่', 'อำเภอเมือง') },
    { key: 7, contno: 'V-0005', date: '2023-04-02', district: 'อำเภอเมือง', province: 'ขอนแก่น', customerList: createCustomerList('ขอนแก่น', 'อำเภอเมือง') },
    { key: 8, contno: 'V-0006', date: '2023-04-18', district: 'อำเภอบางละมุง', province: 'ชลบุรี', customerList: createCustomerList('ชลบุรี', 'อำเภอบางละมุง') },
    { key: 9, contno: 'V-0007', date: '2023-05-05', district: 'อำเภอเมือง', province: 'นครราชสีมา', customerList: createCustomerList('นครราชสีมา', 'อำเภอเมือง') },
    { key: 10, contno: 'V-0008', date: '2023-05-21', district: 'อำเภอเมือง', province: 'ภูเก็ต', customerList: createCustomerList('ภูเก็ต', 'อำเภอเมือง') },
    { key: 11, contno: 'V-0009', date: '2023-06-01', district: 'อำเภอแม่สอด', province: 'ตาก', customerList: createCustomerList('ตาก', 'อำเภอแม่สอด') },
    { key: 12, contno: 'V-0010', date: '2023-06-15', district: 'อำเภอเมือง', province: 'สุราษฎร์ธานี', customerList: createCustomerList('สุราษฎร์ธานี', 'อำเภอเมือง') },
    { key: 13, contno: 'V-0011', date: '2023-07-03', district: 'อำเภอเมือง', province: 'ราชบุรี', customerList: createCustomerList('ราชบุรี', 'อำเภอเมือง') },
    { key: 14, contno: 'V-0012', date: '2023-07-20', district: 'อำเภอเมือง', province: 'พิษณุโลก', customerList: createCustomerList('พิษณุโลก', 'อำเภอเมือง') },
    { key: 15, contno: 'V-0013', date: '2023-08-08', district: 'อำเภอเมือง', province: 'บุรีรัมย์', customerList: createCustomerList('บุรีรัมย์', 'อำเภอเมือง') },
    { key: 16, contno: 'V-0014', date: '2023-08-25', district: 'อำเภอเมือง', province: 'นครสวรรค์', customerList: createCustomerList('นครสวรรค์', 'อำเภอเมือง') },
    { key: 17, contno: 'V-0015', date: '2023-09-10', district: 'อำเภอเมือง', province: 'ลำปาง', customerList: createCustomerList('ลำปาง', 'อำเภอเมือง') },
    { key: 18, contno: 'V-0016', date: '2023-09-28', district: 'อำเภอเมือง', province: 'สมุทรสาคร', customerList: createCustomerList('สมุทรสาคร', 'อำเภอเมือง') },
    { key: 19, contno: 'V-0017', date: '2023-10-12', district: 'อำเภอเมือง', province: 'อุดรธานี', customerList: createCustomerList('อุดรธานี', 'อำเภอเมือง') },
    { key: 20, contno: 'V-0018', date: '2023-10-29', district: 'อำเภอเมือง', province: 'ยะลา', customerList: createCustomerList('ยะลา', 'อำเภอเมือง') },
    { key: 21, contno: 'V-0019', date: '2023-11-15', district: 'อำเภอเมือง', province: 'นครปฐม', customerList: createCustomerList('นครปฐม', 'อำเภอเมือง') },
    { key: 22, contno: 'V-0020', date: '2023-12-01', district: 'อำเภอเมือง', province: 'แพร่', customerList: createCustomerList('แพร่', 'อำเภอเมือง') },
    { key: 23, contno: 'V-0021', date: '2023-12-05', district: 'อำเภอเมือง', province: 'เชียงราย', customerList: createCustomerList('เชียงราย', 'อำเภอเมือง') },
    { key: 24, contno: 'V-0022', date: '2024-01-10', district: 'อำเภอเมือง', province: 'นครศรีธรรมราช', customerList: createCustomerList('นครศรีธรรมราช', 'อำเภอเมือง') },
    { key: 25, contno: 'V-0023', date: '2024-01-20', district: 'อำเภอเมือง', province: 'สมุทรปราการ', customerList: createCustomerList('สมุทรปราการ', 'อำเภอเมือง') },
    { key: 26, contno: 'V-0024', date: '2024-02-05', district: 'อำเภอเมือง', province: 'ชัยภูมิ', customerList: createCustomerList('ชัยภูมิ', 'อำเภอเมือง') },
    { key: 27, contno: 'V-0025', date: '2024-02-20', district: 'อำเภอเมือง', province: 'อ่างทอง', customerList: createCustomerList('อ่างทอง', 'อำเภอเมือง') },
    { key: 28, contno: 'V-0026', date: '2024-03-05', district: 'อำเภอเมือง', province: 'ลพบุรี', customerList: createCustomerList('ลพบุรี', 'อำเภอเมือง') },
    { key: 29, contno: 'V-0027', date: '2024-03-25', district: 'อำเภอเมือง', province: 'สกลนคร', customerList: createCustomerList('สกลนคร', 'อำเภอเมือง') },
    { key: 30, contno: 'V-0028', date: '2024-04-10', district: 'อำเภอเมือง', province: 'แพร่', customerList: createCustomerList('แพร่', 'อำเภอเมือง') },
    { key: 31, contno: 'V-0029', date: '2024-04-28', district: 'อำเภอเมือง', province: 'เพชรบูรณ์', customerList: createCustomerList('เพชรบูรณ์', 'อำเภอเมือง') },
    { key: 32, contno: 'V-0030', date: '2024-05-15', district: 'อำเภอเมือง', province: 'สุโขทัย', customerList: createCustomerList('สุโขทัย', 'อำเภอเมือง') },
];

// export const mockContracts = [
//     {
//         key: 1,
//         contno: 'V-0001',
//         date: '2023-01-01',
//         district: 'อำเภอเมือง',
//         province: 'กรุงเทพ',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '123 ถนนสุขุมวิท กรุงเทพ', phone: '081-111-1111', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '45 ถนนเพชรบุรี กรุงเทพ', phone: '082-222-2222', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '67 ถนนราชดำเนิน กรุงเทพ', phone: '083-333-3333', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 2,
//         contno: 'V-00031',
//         date: '2023-01-01',
//         district: 'เขตคลองเตย',
//         province: 'กรุงเทพ',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '1234 ถนนสุขุมวิท กรุงเทพ', phone: '081-111-1113', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '44 ถนนเพชรบุรี กรุงเทพ', phone: '082-222-2228', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '674 ถนนราชดำเนิน กรุงเทพ', phone: '083-333-3336', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 3,
//         contno: 'V-00032',
//         date: '2023-01-01',
//         district: 'เขตคลองเตย',
//         province: 'กรุงเทพ',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '12345 ถนนสุขุมวิท กรุงเทพ', phone: '081-111-1116', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '445 ถนนเพชรบุรี กรุงเทพ', phone: '082-222-2226', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '6745 ถนนราชดำเนิน กรุงเทพ', phone: '083-333-3336', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 4,
//         contno: 'V-0002',
//         date: '2023-02-15',
//         district: 'อำเภอคลองหลวง',
//         province: 'ปทุมธานี',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '88 หมู่ 5 ปทุมธานี', phone: '084-444-4444', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '99 หมู่ 9 ปทุมธานี', phone: '085-555-5555', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '111 ถนนรังสิต ปทุมธานี', phone: '086-666-6666', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 5,
//         contno: 'V-0003',
//         date: '2023-03-10',
//         district: 'อำเภอหาดใหญ่',
//         province: 'สงขลา',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '22 ถนนกาญจนวนิช สงขลา', phone: '087-777-7777', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '55 ถนนเพชรเกษม สงขลา', phone: '088-888-8888', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '99 ถนนลพบุรีราเมศวร์ สงขลา', phone: '089-999-9999', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 6,
//         contno: 'V-0004',
//         date: '2023-03-25',
//         district: 'อำเภอเมือง',
//         province: 'เชียงใหม่',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '12 ถนนนิมมานฯ เชียงใหม่', phone: '090-111-2233', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '33 ถนนสุเทพ เชียงใหม่', phone: '091-222-3344', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '44 ถนนเจริญเมือง เชียงใหม่', phone: '092-333-4455', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 7,
//         contno: 'V-0005',
//         date: '2023-04-02',
//         district: 'อำเภอเมือง',
//         province: 'ขอนแก่น',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '111 ถนนมิตรภาพ ขอนแก่น', phone: '093-444-5566', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '222 ถนนศรีจันทร์ ขอนแก่น', phone: '094-555-6677', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '333 ถนนกลางเมือง ขอนแก่น', phone: '095-666-7788', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 8,
//         contno: 'V-0006',
//         date: '2023-04-18',
//         district: 'อำเภอบางละมุง',
//         province: 'ชลบุรี',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '55 ถนนสุขุมวิท ชลบุรี', phone: '096-777-8899', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '66 ถนนบางละมุง ชลบุรี', phone: '097-888-9900', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '77 ถนนพัทยา ชลบุรี', phone: '098-999-0011', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 9,
//         contno: 'V-0007',
//         date: '2023-05-05',
//         district: 'อำเภอเมือง',
//         province: 'นครราชสีมา',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '10 ถนนมิตรภาพ นครราชสีมา', phone: '099-000-1122', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '20 ถนนราชดำเนิน นครราชสีมา', phone: '090-111-2233', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '30 ถนนกลางเมือง นครราชสีมา', phone: '091-222-3344', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 10,
//         contno: 'V-0008',
//         date: '2023-05-21',
//         district: 'อำเภอเมือง',
//         province: 'ภูเก็ต',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '100 ถนนถลาง ภูเก็ต', phone: '092-333-4455', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '101 ถนนเยาวราช ภูเก็ต', phone: '093-444-5566', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '102 ถนนรัษฎา ภูเก็ต', phone: '094-555-6677', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 11,
//         contno: 'V-0009',
//         date: '2023-06-01',
//         district: 'อำเภอแม่สอด',
//         province: 'ตาก',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '12 ถนนริมเมย ตาก', phone: '095-666-7788', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '13 ถนนสุขสวัสดิ์ ตาก', phone: '096-777-8899', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '14 ถนนมหาราช ตาก', phone: '097-888-9900', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 12,
//         contno: 'V-0010',
//         date: '2023-06-15',
//         district: 'อำเภอเมือง',
//         province: 'สุราษฎร์ธานี',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '50 ถนนนารายณ์ สุราษฎร์ธานี', phone: '098-999-0011', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '51 ถนนเกษตร สุราษฎร์ธานี', phone: '099-000-1122', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '52 ถนนศรีวิชัย สุราษฎร์ธานี', phone: '090-111-2233', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 13,
//         contno: 'V-0011',
//         date: '2023-07-03',
//         district: 'อำเภอเมือง',
//         province: 'ราชบุรี',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '12 ถนนจันทร์ ราชบุรี', phone: '091-222-3344', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '13 ถนนประจักษ์ ราชบุรี', phone: '092-333-4455', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '14 ถนนวรเดช ราชบุรี', phone: '093-444-5566', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 14,
//         contno: 'V-0012',
//         date: '2023-07-20',
//         district: 'อำเภอเมือง',
//         province: 'พิษณุโลก',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '1 ถนนบรมไตรโลกนารถ พิษณุโลก', phone: '094-555-6677', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '2 ถนนพิชัย พิษณุโลก', phone: '095-666-7788', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '3 ถนนจันทน์แก้ว พิษณุโลก', phone: '096-777-8899', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 15,
//         contno: 'V-0013',
//         date: '2023-08-08',
//         district: 'อำเภอเมือง',
//         province: 'บุรีรัมย์',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '10 ถนนกุดพิมาน บุรีรัมย์', phone: '097-888-9900', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '11 ถนนสรรพสิทธิ์ บุรีรัมย์', phone: '098-999-0011', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '12 ถนนจิระ บุรีรัมย์', phone: '099-000-1122', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 16,
//         contno: 'V-0014',
//         date: '2023-08-25',
//         district: 'อำเภอเมือง',
//         province: 'นครสวรรค์',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '50 ถนนโคกเดื่อ นครสวรรค์', phone: '090-111-2233', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '51 ถนนสวรรค์ชัยชาญ นครสวรรค์', phone: '091-222-3344', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '52 ถนนนวมินทร์ นครสวรรค์', phone: '092-333-4455', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 17,
//         contno: 'V-0015',
//         date: '2023-09-10',
//         district: 'อำเภอเมือง',
//         province: 'ลำปาง',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '10 ถนนเจริญเมือง ลำปาง', phone: '093-444-5566', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '11 ถนนรอบเมือง ลำปาง', phone: '094-555-6677', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '12 ถนนพหลโยธิน ลำปาง', phone: '095-666-7788', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 18,
//         contno: 'V-0016',
//         date: '2023-09-28',
//         district: 'อำเภอเมือง',
//         province: 'สมุทรสาคร',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '1 ถนนเศรษฐกิจ สมุทรสาคร', phone: '096-777-8899', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '2 ถนนสมุทรสาคร สมุทรสาคร', phone: '097-888-9900', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '3 ถนนมหาชัย สมุทรสาคร', phone: '098-999-0011', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 19,
//         contno: 'V-0017',
//         date: '2023-10-12',
//         district: 'อำเภอเมือง',
//         province: 'อุดรธานี',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '10 ถนนกลางเมือง อุดรธานี', phone: '099-000-1122', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '11 ถนนประจักษ์ อุดรธานี', phone: '090-111-2233', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '12 ถนนทหาร อุดรธานี', phone: '091-222-3344', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 2,
//         contno: 'V-0018',
//         date: '2023-10-29',
//         district: 'อำเภอเมือง',
//         province: 'ยะลา',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '1 ถนนสันติสุข ยะลา', phone: '092-333-4455', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '2 ถนนยะลาใหม่ ยะลา', phone: '093-444-5566', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '3 ถนนจรัสมิตร ยะลา', phone: '094-555-6677', role: 'guarantor', investigation: true }
//         ]
//     },
//     {
//         key: 21,
//         contno: 'V-0019',
//         date: '2023-11-15',
//         district: 'อำเภอเมือง',
//         province: 'นครปฐม',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '10 ถนนเพชรเกษม นครปฐม', phone: '095-666-7788', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '11 ถนนราชดำเนิน นครปฐม', phone: '096-777-8899', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '12 ถนนรัตนโกสินทร์ นครปฐม', phone: '097-888-9900', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 22,
//         contno: 'V-0020',
//         date: '2023-12-01',
//         district: 'อำเภอเมือง',
//         province: 'แพร่',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '1 ถนนเจริญเมือง แพร่', phone: '098-999-0011', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '2 ถนนสิงห์ชัย แพร่', phone: '099-000-1122', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '3 ถนนพญาไท แพร่', phone: '090-111-2233', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 23,
//         contno: 'V-0021',
//         date: '2023-12-05',
//         district: 'อำเภอเมือง',
//         province: 'เชียงราย',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '10 ถนนแม่ฟ้าหลวง เชียงราย', phone: '091-222-3344', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '11 ถนนประสานมิตร เชียงราย', phone: '092-333-4455', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '12 ถนนสิงหราช เชียงราย', phone: '093-444-5566', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 24,
//         contno: 'V-0022',
//         date: '2024-01-10',
//         district: 'อำเภอเมือง',
//         province: 'นครศรีธรรมราช',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '50 ถนนท่าแพ นครศรีธรรมราช', phone: '094-555-6677', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '51 ถนนพัฒนาการ นครศรีธรรมราช', phone: '095-666-7788', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '52 ถนนราชดำเนิน นครศรีธรรมราช', phone: '096-777-8899', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 25,
//         contno: 'V-0023',
//         date: '2024-01-20',
//         district: 'อำเภอเมือง',
//         province: 'สมุทรปราการ',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '1 ถนนสุขุมวิท สมุทรปราการ', phone: '097-888-9900', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '2 ถนนบางนา สมุทรปราการ', phone: '098-999-0011', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '3 ถนนปู่เจ้าสมิงพราย สมุทรปราการ', phone: '099-000-1122', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 26,
//         contno: 'V-0024',
//         date: '2024-02-05',
//         district: 'อำเภอเมือง',
//         province: 'ชัยภูมิ',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '10 ถนนจิระชัย ชัยภูมิ', phone: '090-111-2233', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '11 ถนนหน้าเมือง ชัยภูมิ', phone: '091-222-3344', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '12 ถนนสระบุรี ชัยภูมิ', phone: '092-333-4455', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 27,
//         contno: 'V-0025',
//         date: '2024-02-20',
//         district: 'อำเภอเมือง',
//         province: 'อ่างทอง',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '1 ถนนอ่างทอง อ่างทอง', phone: '093-444-5566', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '2 ถนนบางระกำ อ่างทอง', phone: '094-555-6677', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '3 ถนนศรีอ่างทอง อ่างทอง', phone: '095-666-7788', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 28,
//         contno: 'V-0026',
//         date: '2024-03-05',
//         district: 'อำเภอเมือง',
//         province: 'ลพบุรี',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '10 ถนนพหลโยธิน ลพบุรี', phone: '096-777-8899', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '11 ถนนประตูชัย ลพบุรี', phone: '097-888-9900', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '12 ถนนสิงห์ ลพบุรี', phone: '098-999-0011', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 29,
//         contno: 'V-0027',
//         date: '2024-03-25',
//         district: 'อำเภอเมือง',
//         province: 'สกลนคร',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '1 ถนนราษฎร์บำรุง สกลนคร', phone: '099-000-1122', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '2 ถนนสุขเกษม สกลนคร', phone: '090-111-2233', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '3 ถนนวิสุทธิกษัตริย์ สกลนคร', phone: '091-222-3344', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 30,
//         contno: 'V-0028',
//         date: '2024-04-10',
//         district: 'อำเภอเมือง',
//         province: 'แพร่',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '10 ถนนประสิทธิ์ แพร่', phone: '092-333-4455', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '11 ถนนสิงห์ชัย แพร่', phone: '093-444-5566', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '12 ถนนพญาไท แพร่', phone: '094-555-6677', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 31,
//         contno: 'V-0029',
//         date: '2024-04-28',
//         district: 'อำเภอเมือง',
//         province: 'เพชรบูรณ์',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '1 ถนนสระประทุม เพชรบูรณ์', phone: '095-666-7788', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '2 ถนนชัยบาดาล เพชรบูรณ์', phone: '096-777-8899', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '3 ถนนเพชรเกษม เพชรบูรณ์', phone: '097-888-9900', role: 'คนค้ำ 2', investigation: true }
//         ]
//     },
//     {
//         key: 32,
//         contno: 'V-0030',
//         date: '2024-05-15',
//         district: 'อำเภอเมือง',
//         province: 'สุโขทัย',
//         customerList: [
//             { SNAM: 'นาย', NAME1: 'ก', NAME2: 'ก1', address: '10 ถนนสวรรคโลก สุโขทัย', phone: '098-999-0011', role: 'คนกู้', investigation: true },
//             { SNAM: 'นาง', NAME1: 'ข', NAME2: 'ข1', address: '11 ถนนเมืองเก่า สุโขทัย', phone: '099-000-1122', role: 'คนค้ำ 1', investigation: true },
//             { SNAM: 'นางสาว', NAME1: 'ค', NAME2: 'ค1', address: '12 ถนนพิพิธภัณฑ์ สุโขทัย', phone: '090-111-2233', role: 'คนค้ำ 2', investigation: true }
//         ]
//     }
// ];


